import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6gwiq2eawl: FaireBrandEntity = {
  token: "b_6gwiq2eawl",
  type: "brand",
  name: "PatchAid",
  avatarUrl:
    "https://cdn.faire.com/fastly/6d5bcc6d2ce8a10084286dd90e98641296ac920330184b284f5f9887ab8afc4b.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/00b1e489b4d6884851862c7d27b9e90d74fc6e96ba0bfaa84ae1f6472560306a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/6d5bcc6d2ce8a10084286dd90e98641296ac920330184b284f5f9887ab8afc4b.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/00b1e489b4d6884851862c7d27b9e90d74fc6e96ba0bfaa84ae1f6472560306a.jpeg",
  location: "Albany, NY, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 91,
  isTopShop: true,
  isInsider: true,
  description:
    "PatchAid is a leader in innovative health solutions, offering easy-to-use vitamin and nutrient patches that deliver essential nutrients directly through the skin for faster, more effective absorption. We stand out by making wellness accessible and convenient—no more bulky pills, messy powders, or sugary gummies. Stick on a PatchAid patch, and you’re ready to go!\n\nOur extensive product range is designed to meet various health needs, from daily multivitamins to targeted patches for energy, sleep, immune support, and skincare. Each patch is formulated with high-quality ingredients, ensuring you get the nutrients without additives or fillers. PatchAid's products are designed for people who value convenience without compromising quality.\n\nWhat sets PatchAid apart is our dedication to improving the customer experience. Our patches are thin, easy to wear, and can be used discreetly day or night. Whether you are seeking weight management support, energy boosts, or better sleep, PatchAid patches fit effortlessly into your daily routine.\n\nThousands of customers trust PatchAid for their health and wellness needs, as we consistently receive positive reviews for our effectiveness and ease of use. Join the PatchAid community today and discover how simple staying healthy can be.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:39.441Z",
    importedBy: "entity-db-cli",
  },
};
